export enum BorrowerPlatformStateType {
  ApplicationIncomplete = "application_incomplete",
  ApplicationComplete = "application_complete",
  Underwriting = "underwriting",
  Scorecards = "scorecards",
  NoPlacements = "no_placements",
  PlacementSubmitted = "placement_submitted",
  NoOffers = "no_offers",
  OfferReceived = "offer_received",
  OfferAccepted = "offer_accepted",
  OfferStipsIncomplete = "offer_stips_incomplete",
  OfferStipsComplete = "offer_stips_complete",
  Checkout = "checkout",
  Funded = "funded",
  Dead = "dead",
}

export enum WelcomePageType {
  AI_AGENT = "ai_agent",
  LOGIN = "login",
}

export enum BorrowerPlatformTileHeaderType {
  H1 = "h1",
  H2 = "h2",
  H3 = "h3",
  H4 = "h4",
  H5 = "h5",
  None = "none",
}

export enum BorrowerPlatformTileLayoutType {
  OneColumn = "1-column",
  TwoColumn = "2-column",
  ThreeColumn = "3-column",
}

export enum TabType {
  WELCOME_PAGE = "welcome_page",
  WORKFLOW = "workflow",
  PROFILE = "profile",
  DOCUMENTS = "documents",
  CUSTOM = "custom",
  FAQ = "faq",
  LOG_OUT = "log_out",
}

export enum NavigationPosition {
  TOP = "top",
  BOTTOM = "bottom",
}

export enum TabVisibility {
  ALWAYS = "always",
  AUTHENTICATED = "authenticated",
  UNAUTHENTICATED = "unauthenticated",
}

export enum BlockType {
  ILLUSTRATION = "illustration",
  IMAGE = "image",
  BUTTON = "button",
  TEXT = "text",
  TILES = "tiles",
}

export enum BlockAlignment {
  LEFT = "left",
  CENTER = "center",
}

export enum BlockLayout {
  ONE_COLUMN = "1-column",
  TWO_COLUMNS = "2-columns",
}

export enum HeadingLevel {
  H1 = "h1",
  H2 = "h2",
  H3 = "h3",
  H4 = "h4",
}

export enum TileActionType {
  BUTTON = "button",
  REDIRECT_LINK = "redirect_link",
  NONE = "none",
}

export enum TileImageType {
  ILLUSTRATION = "illustration",
  IMAGE = "image",
  NONE = "none",
}

export enum DimensionsMode {
  SCALE = "scale",
  FULL_WIDTH = "full_width",
}

export enum EditorTabs {
  WELCOME_PAGE = "welcome_page",
  TABS = "tabs",
  FOOTER = "footer",
}

export interface TilesContentControlValue {
  image: TileImageType;
  header: BorrowerPlatformTileHeaderType;
  button: TileActionType;
}
